import { Component } from '@angular/core';
import { ActivatedRouteSnapshot, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { routerAnimationOne } from './core/_animations/router-animations.contants';
import { NavigationBar } from '@mauricewegner/capacitor-navigation-bar';
import { Subscription, combineLatest } from 'rxjs';
import { checkConnectivityService } from './core/_services/check-connectivity.services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LayoutUtilsServices, MessageType } from './core/_services/layout-utils.services';
import { Store, select } from '@ngrx/store';
import { AppState } from './core/_reducers';
import { StoreModel } from './core/_models/store.model';
import { currentStore } from './core/_reducers/_selectors/store.selector';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { InactivityService } from './core/_services/inactivity.services';

@Component({
  selector: 'forrest-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [routerAnimationOne]
})
export class AppComponent {
  title = 'Wibo';
  snackbarClose: any | null = null;
  storeData: StoreModel = new StoreModel()
  private subscriptions: Subscription[] = []
  constructor(
    private router: Router,
    private store: Store<AppState>,
    private _translateService: TranslateService,
    private _layoutUtilsService: LayoutUtilsServices,
    private snackBar: MatSnackBar,
    private titleService: Title,
    private conexionService: checkConnectivityService,
    private _inactivityService: InactivityService,
  ) { 
    const language = localStorage.getItem('language');
    this._translateService.use(language || this._translateService.getBrowserLang());
  }

  ngOnInit() {
    let screens: any = screen
    // console.log()
    // StatusBar.hide().then(() => {});
    NavigationBar.hide().then(() => {});
    var orientation = (screens.orientation || {}).type || screens?.mozOrientation || screens?.msOrientation;

    // alert(`${window.innerWidth} / ${screen.width} / / ${window.innerHeight} / ${screen.height} / ${orientation}`)

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const urlTree = this.router.parseUrl(event.url);
        if (urlTree.queryParamMap.keys.length === 0) {
          window.scrollTo(0, 0);
        }

        let route = this.router.routerState.root.snapshot;
        let title = this.getTitle(route);

        if (title) {
          const translatedTitle = this._translateService.instant(title);
          const timeout = setTimeout(() => {
            this.titleService.setTitle(translatedTitle);
            document.title = translatedTitle;
            clearTimeout(timeout);
          }, 50)
        }
      }
    });

    this.subscriptions.push(
      combineLatest([
        this.conexionService.isConnected$,
        this.conexionService.speed$
      ]).subscribe(([isConnected, speed]) => {
        let valid = true;
        let messages = 'GENERAL.NETWORK'
        if(speed== '2g' || !isConnected){
          valid = false
        }
        if (!valid && !this.snackbarClose) {
          this.snackbarClose =  this._layoutUtilsService.showNotification(
            messages, MessageType.Warning, 30000, true, true, 10000, "top")
          this.snackbarAfterDismissed(this.snackbarClose)

          }
        if(valid && this.snackbarClose){
          this.snackBar.dismiss();
        }
      }));
    this.subscriptions.push(
      this.store.pipe(select(currentStore)).subscribe(res => {
        this.storeData = res
      })
    )
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sb => sb.unsubscribe());
  }

  snackbarAfterDismissed (snackBarRef: any ){
    snackBarRef?.afterDismissed()?.subscribe((res : any) => {
      this.snackbarClose = null;
    });
  }

  getAnimationState(outlet: RouterOutlet) {
    return outlet?.isActivated ? outlet?.activatedRoute : { toString: () => '' };
  }

  getTitle(routeSnapshot: ActivatedRouteSnapshot): string | null | any {
    if (routeSnapshot.firstChild) {
      return this.getTitle(routeSnapshot.firstChild);
    }
    if (routeSnapshot.data['title']) {
      return routeSnapshot.data['title'];
    }
    return routeSnapshot.routeConfig && routeSnapshot.routeConfig['title'] ? routeSnapshot.routeConfig['title'] : null;
  }
}
